<script setup lang="ts">
    import { UnwrapNestedRefs } from 'vue';
    import Tenant from '@/app/auth/models/Tenant';
    defineProps<{ tenant: UnwrapNestedRefs<Tenant> }>();
    const {
        modal: { open },
    } = useTenantLiveModeModal();
</script>

<template>
    <CollapsibleBanner
        class="text-white"
        style="background: linear-gradient(to right, #ff8a46, #d44e00)"
    >
        <template #title>
            <p class="font-bold text-base leading-tight">
                {{ $t('tenancy.tenant.mode.alert.title') }}
            </p>
        </template>
        <template #body>
            <p class="leading-tight text-[13px] max-md:text-sm max-md:leading-snug">
                <span class="hidden md:inline">{{ $t('tenancy.tenant.mode.alert.text') }}</span>
                <span class="md:hidden">{{ $t('tenancy.tenant.mode.alert.text_sm') }}</span>
            </p>
        </template>
        <template #action>
            <LoadingButton
                class-name="flex items-center gap-1.5 h-[26px] px-2.5 bg-white border border-gray-300 rounded text-gray-700 text-[11px] font-medium shadow-sm hover:bg-gray-50 max-md:h-[36px] max-md:px-3 max-md:text-sm max-md:justify-center"
                @clicked="open(tenant)"
            >
                <i
                    class="fa-regular fa-trash text-[12px]"
                    aria-hidden="true"
                ></i>
                <span>{{ $t('actions.exit_test_mode') }}</span>
            </LoadingButton>
        </template>
    </CollapsibleBanner>
</template>
